/* @flow */
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import {
  setSelectedPair,
  setSelectedStableCoinTabs,
} from '../actions/settings';
import { setNativeCurrency } from '../actions/load';
import { getItem } from '../utils/localStorage';

const USER_PREFERRED_CURRENCY_KEY = 'userPreferredCurrency';

export type Props = {
  setSelectedPair: Function,
  setSelectedStableCoinTabs: Function,
  setNativeCurrency: Function,
  router: Object,
};

export default
@connect(
  null,
  {
    setSelectedPair,
    setSelectedStableCoinTabs,
    setNativeCurrency,
  }
)
class LocalStorageDataProvider extends PureComponent<Props> {
  componentDidMount() {
    const pairLabel = 'bn.selectedPair';
    const stableCoinTabsLabel = 'bn.selectedStableCoinTabs';
    const selectedPair = getItem(window.localStorage, pairLabel);
    const selectedStableCoinTabs = JSON.parse(getItem(window.localStorage, stableCoinTabsLabel));
    const userPreferredCurrency = getItem(window.localStorage, USER_PREFERRED_CURRENCY_KEY);
    if (selectedPair) this.props.setSelectedPair(selectedPair);
    if (selectedStableCoinTabs) this.props.setSelectedStableCoinTabs(selectedStableCoinTabs);
    if (userPreferredCurrency) {
      this.props.setNativeCurrency({
        configType: USER_PREFERRED_CURRENCY_KEY,
        configName: userPreferredCurrency,
      });
    }
  }

  render() {
    return null;
  }
}
